// ธีมสี (data-theme บน <html>) — Turbo สลับหน้าแค่ <body> ไม่แตะแอตทริบิวต์ของ <html>
// ถ้าไม่ซิงก์: เข้าแดชบอร์ดจากหน้าอื่นจะค้างมืด / ออกจากแดชบอร์ดไปหน้าที่ยังไม่รองรับจะค้างสว่าง (อ่านไม่ออก)
// layout ใส่ data-theme ไว้ที่ <body> ด้วย → คัดลอกขึ้น <html> ก่อน Turbo วาดหน้าใหม่ (รวมหน้าจาก cache) ไม่มีกระพริบ
document.addEventListener("turbo:before-render", (event) => {
  const theme = event.detail.newBody?.dataset.theme
  if (theme) document.documentElement.dataset.theme = theme
})
